import { createAction, props } from '@ngrx/store';
import { IDebitCard } from '../../add-debit/models/debit-card.model';
import { IAddCard, IAddCardResponse, IAddDebitResponse } from '../models/addCreditCard.model';

export const loadAddCreditCards = createAction('[AddCreditCard] Load AddCreditCards', props<{ request: IAddCard; businessId: string }>());

export const loadAddCreditCardsSuccess = createAction(
  '[AddCreditCard] Load AddCreditCards Success',
  props<{ response: IAddCardResponse }>()
);

export const loadAddCreditCardsFailure = createAction('[AddCreditCard] Load AddCreditCards Failure', props<{ error: Error | any }>());

export const loadAddDebitCards = createAction('[AddCreditCard] Load loadAddDebit', props<{ request: IDebitCard; businessId: string }>());

export const loadAddDebitSuccess = createAction('[AddCreditCard] Load loadAddDebit Success', props<{ response: IAddDebitResponse }>());

export const loadAddDebitFailure = createAction('[AddCreditCard] Load loadAddDebit Failure', props<{ error: Error | any }>());
